import React, { useState } from "react";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Checkbox from "@mui/material/Checkbox";
import { DeliveryInvoiceBatchDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { PrimaryReturnBatchDetails } from "./PrimaryReturnEdit";
import MultiQtyCell from "../../components/dms_common/MultiQtyCell";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import { withoutGRNBatchDetails } from "./PrimaryReturnWithoutGRNEdit";
import PrimaryReturnQtyCell from "./PrimaryReturnQtyCell";


const PrimaryReturnWithoutGRNBatchItem = ({
  batch,
  editBatchId,
  isSelected,
  onSelect,
  isUpdated,
  isMarked,
}: {
  batch: withoutGRNBatchDetails;
  editBatchId?: (batchId: string)=>void;
  isSelected: boolean;
  onSelect: () => void;
  isUpdated?: boolean
  otherUnitName?: string;
  isMarked?: boolean;
}) => {
  
  return (
    <div
      className={`batchContainer-delivery ${(isSelected || isUpdated) && "batch-selected-delivery"}`}
      onClick={onSelect}
    >
      <span className={`${(isSelected || isUpdated) && "batch-selected-delivery-text"}`} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {batch?.batchId}{" "}
        {isMarked && (
          <CheckCircleIcon
            style={{
              fontSize: "14px",
              verticalAlign: "middle",
              color: "#00C6B1",
            }}
          />
        )}
      </span>
      <div className="cs-pc-and-checkbox" style={{display: "flex", flexDirection: "column", gap: "2px"}}>
        <div className="batch-input-container">

          <div style={{display: "flex", flexDirection: "column", gap: "4px"}}>

          <PrimaryReturnQtyCell
            csQty={batch.unsellableCaseQty ?? 0}
            pcQty={batch.unsellablePieceQty ?? 0}
            otherQty={batch.unsellableOtherQty ?? 0}
            customStyles={{
              boxStyle: {
                border: "1px solid #FFB8B8",
                backgroundColor: "#FFF8F8",
              }
            }}
            otherUnitName={batch.otherUnitName}
          />

              
          </div>
          <input
          className="batchListItem-radio-button"
          type="radio"
          id="selected"
          checked={isSelected} />
        </div>
        
      </div>
    </div>
  );
};

export default PrimaryReturnWithoutGRNBatchItem;
